var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconVideo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-video",
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icon-video .a{fill:#2d2d2d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.506,4.5H1.494A1.494,1.494,0,0,0,0,5.994v9.013A1.494,1.494,0,0,0,1.494,16.5h9.013A1.494,1.494,0,0,0,12,15.006V5.994A1.494,1.494,0,0,0,10.506,4.5Zm5.919,1.178L13,8.041v4.919l3.425,2.359A1,1,0,0,0,18,14.512V6.484A1,1,0,0,0,16.425,5.678Z",
    transform: "translate(0 -4.5)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconVideo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_video.580715e4.svg";
export { ForwardRef as ReactComponent };